import CircularProgress from "@mui/material/CircularProgress";
import React, { useEffect } from "react";
import { useDispatch } from "react-redux";
import { HashRouter, Route, Routes } from "react-router-dom";
import { AuthPage } from "../pages/authPages/loginPage/AuthPage";
import { MainPageLayout } from "../pages/mainPages/MainPageLayout";

import { roleTypes } from "../shared/types/types";
import { DashboardLayout } from "../pages/dashboard/DashboardLayout";
import { checkAuthorization } from "../helpers/utilities";
import { ClientLayout } from "../pages/clientsPages/ClientLayout";
import { FcmTransferFormikNew } from "../pages/clientsPages/FcmTransferFormikNew";
import { PackagePrint } from "../pages/other/PackagePrint";
import { useAppDispatch, useAppSelector } from "../hooks";
import { startCheckingNew } from "../store/thunks/authThunks";
import ForgotPassword from "../pages/authPages/loginPage/ForgotPassword";
import { perfMark } from "../utils/perf-tracker";
import { FacturacionLayout } from "../pages/facturacion/FacturacionLayout";
import { SiteLayout } from "../pages/mainPages/components/SiteLayout";
import { LoginPage } from "../pages/facturacion/auth/LoginPage";
import { RegisterPage } from "../pages/facturacion/auth/RegisterPage";
import { ForgotPasswordPage } from "../pages/facturacion/auth/ForgotPasswordPage";
import { CreatePasswordPage } from "../pages/facturacion/auth/CreatePasswordPage";
import { CmdKSearch } from "../components/CmdKSearch/CmdKSearch";

export const AppRouter = () => {
  const dispatch = useDispatch();
  const dispatch2 = useAppDispatch();
  const { user, isLoading } = useAppSelector((state) => state.authReducer);
  const role = user ? user.role : null; // Safely access role2 only if user is defined

  // todo check this

  useEffect(() => {
    perfMark("auth-check-start");
    dispatch2(startCheckingNew());
  }, [dispatch, dispatch2]);

  if (isLoading) {
    return <CircularProgress />;
  }

  perfMark("auth-check-done");

  return (
    <HashRouter>
      <Routes>
        {checkAuthorization(role!, roleTypes.collaborator) && (
          <Route path="/dashboard/*" element={<DashboardLayout />}></Route>
        )}

        <Route path="/auth" element={<SiteLayout><AuthPage /></SiteLayout>}></Route>
        <Route
          path="/auth/forgot-password"
          element={<SiteLayout><ForgotPassword /></SiteLayout>}
        ></Route>
        <Route path="/auth/:token" element={<SiteLayout><AuthPage /></SiteLayout>}></Route>
        {role === "User" && (
          <Route path="/clients/*" element={<ClientLayout />}></Route>
        )}

        <Route path="/facturacion/login" element={<SiteLayout><LoginPage /></SiteLayout>} />
        <Route path="/facturacion/registro" element={<SiteLayout><RegisterPage /></SiteLayout>} />
        <Route path="/facturacion/recuperar-contrasena" element={<SiteLayout><ForgotPasswordPage /></SiteLayout>} />
        <Route path="/facturacion/crear-contrasena" element={<SiteLayout><CreatePasswordPage /></SiteLayout>} />
        <Route path="/facturacion/*" element={<FacturacionLayout />} />
        <Route path="/*" element={<MainPageLayout />}></Route>
        <Route path="/test" element={<FcmTransferFormikNew />}></Route>
        <Route
          path="/other/print/fcmPackage/:fcmPackageId"
          element={<PackagePrint />}
        ></Route>
        {/* <Route path="*" element={<LoginPage />} /> */}
        {/* <Route path="/auth/register" element={<LoginPage />} /> */}
      </Routes>
      <CmdKSearch />
    </HashRouter>
  );
};
